// Misc

import MiscChevronLeft from '~/assets/images/icons/misc/chevron-left.svg';
import MiscChevronRight from '~/assets/images/icons/misc/chevron-right.svg';
import MiscSpinner from '~/assets/images/icons/misc/spinner.svg';
import MiscYaPay from '~/assets/images/icons/misc/yapay.svg';
import MiscYaSplit from '~/assets/images/icons/misc/yasplit.svg';
import MiscVideo from '~/assets/images/icons/misc/video.svg';

// 32 frame size

import MapMarkerWhite32 from '~/assets/images/icons/32/map-marker-white.svg';
import Play32 from '~/assets/images/icons/32/play.svg';
import MapMinus32 from '~/assets/images/icons/32/map-minus.svg';
import MapPlus32 from '~/assets/images/icons/32/map-plus.svg';

// 24 frame size

import ArrowLeft24 from '~/assets/images/icons/24/arrow-left.svg';
import ArrowRight24 from '~/assets/images/icons/24/arrow-right.svg';
import Attach24 from '~/assets/images/icons/24/attach.svg';
import Book24 from '~/assets/images/icons/24/book.svg';
import Burger24 from '~/assets/images/icons/24/burger.svg';
import Calendar24 from '~/assets/images/icons/24/calendar.svg';
import Cart24 from '~/assets/images/icons/24/cart.svg';
import Check24 from '~/assets/images/icons/24/check.svg';
import ChevronDown24 from '~/assets/images/icons/24/chevron-down.svg';
import ChevronLeft24 from '~/assets/images/icons/24/chevron-left.svg';
import ChevronRight24 from '~/assets/images/icons/24/chevron-right.svg';
import ChevronUp24 from '~/assets/images/icons/24/chevron-up.svg';
import CloseSmall24 from '~/assets/images/icons/24/close-small.svg';
import Close24 from '~/assets/images/icons/24/close.svg';
import Copy24 from '~/assets/images/icons/24/copy.svg';
import Delete24 from '~/assets/images/icons/24/delete.svg';
import Dots24 from '~/assets/images/icons/24/dots.svg';
import Download24 from '~/assets/images/icons/24/download.svg';
import Edit24 from '~/assets/images/icons/24/edit.svg';
import Eye24 from '~/assets/images/icons/24/eye.svg';
import EyeSlash24 from '~/assets/images/icons/24/eye-slash.svg';
import HeartFilled24 from '~/assets/images/icons/24/heart-filled.svg';
import Heart24 from '~/assets/images/icons/24/heart.svg';
import Info24 from '~/assets/images/icons/24/info.svg';
import Layout224 from '~/assets/images/icons/24/layout-2.svg';
import Layout24 from '~/assets/images/icons/24/layout.svg';
import Logo24 from '~/assets/images/icons/24/logo.svg';
import Max24 from '~/assets/images/icons/24/max.svg';
import Minus24 from '~/assets/images/icons/24/minus.svg';
import Ok24 from '~/assets/images/icons/24/ok.svg';
import Options24 from '~/assets/images/icons/24/options.svg';
import Photo24 from '~/assets/images/icons/24/photo.svg';
import Pin24 from '~/assets/images/icons/24/pin.svg';
import Plus24 from '~/assets/images/icons/24/plus.svg';
import Search24 from '~/assets/images/icons/24/search.svg';
import Search224 from '~/assets/images/icons/24/search-2.svg';
import Share24 from '~/assets/images/icons/24/share.svg';
import Shop24 from '~/assets/images/icons/24/shop.svg';
import Telegram24 from '~/assets/images/icons/24/telegram.svg';
import Truck24 from '~/assets/images/icons/24/truck.svg';
import UserNotification24 from '~/assets/images/icons/24/user-notification.svg';
import User24 from '~/assets/images/icons/24/user.svg';
import Vk24 from '~/assets/images/icons/24/vk.svg';
import Wallet24 from '~/assets/images/icons/24/wallet.svg';
import Play24 from '~/assets/images/icons/24/play.svg';

// 16 frame size

import ArrowLeft16 from '~/assets/images/icons/16/arrow-left.svg';
import ArrowRight16 from '~/assets/images/icons/16/arrow-right.svg';
import Attention16 from '~/assets/images/icons/16/attention.svg';
import Bonus16 from '~/assets/images/icons/16/bonus.svg';
import CheckBold16 from '~/assets/images/icons/16/check-bold.svg';
import Check16 from '~/assets/images/icons/16/check.svg';
import ChevronDown16 from '~/assets/images/icons/16/chevron-down.svg';
import ChevronLeft16 from '~/assets/images/icons/16/chevron-left.svg';
import ChevronRight16 from '~/assets/images/icons/16/chevron-right.svg';
import ChevronUp16 from '~/assets/images/icons/16/chevron-up.svg';
import Circle16 from '~/assets/images/icons/16/circle.svg';
import Cross216 from '~/assets/images/icons/16/cross-2.svg';
import Delete16 from '~/assets/images/icons/16/delete.svg';
import Download16 from '~/assets/images/icons/16/download.svg';
import Edit21 from '~/assets/images/icons/16/edit.svg';
import Edit216 from '~/assets/images/icons/16/edit-2.svg';
import Exit16 from '~/assets/images/icons/16/exit.svg';
import Filter16 from '~/assets/images/icons/16/filter.svg';
import Info16 from '~/assets/images/icons/16/info.svg';
import Layout16 from '~/assets/images/icons/16/layout.svg';
import Layout216 from '~/assets/images/icons/16/layout-2.svg';
import Minus16 from '~/assets/images/icons/16/minus.svg';
import Plus16 from '~/assets/images/icons/16/plus.svg';
import Question16 from '~/assets/images/icons/16/question.svg';
import Sort16 from '~/assets/images/icons/16/sort.svg';

export namespace EIcon {
  const images = {
    MiscChevronLeft,
    MiscChevronRight,
    MapMarkerWhite32,
    Play32,
    MapMinus32,
    MapPlus32,
    ArrowLeft24,
    Play24,
    ArrowRight24,
    Attach24,
    Book24,
    Burger24,
    Calendar24,
    Cart24,
    Check24,
    ChevronDown24,
    ChevronLeft24,
    ChevronRight24,
    ChevronUp24,
    CloseSmall24,
    Close24,
    Copy24,
    Delete24,
    Dots24,
    Download24,
    Edit24,
    Eye24,
    EyeSlash24,
    HeartFilled24,
    Heart24,
    Info24,
    Layout224,
    Layout24,
    Logo24,
    Max24,
    Minus24,
    Ok24,
    Options24,
    Photo24,
    Pin24,
    Plus24,
    Search24,
    Search224,
    Share24,
    Shop24,
    Telegram24,
    Truck24,
    UserNotification24,
    User24,
    Vk24,
    Wallet24,
    ArrowLeft16,
    ArrowRight16,
    Attention16,
    Bonus16,
    CheckBold16,
    Check16,
    ChevronDown16,
    ChevronLeft16,
    ChevronRight16,
    ChevronUp16,
    Circle16,
    Cross216,
    Delete16,
    Download16,
    Edit21,
    Edit216,
    Exit16,
    Filter16,
    Info16,
    Layout16,
    Layout216,
    Minus16,
    Plus16,
    Question16,
    Sort16,
    MiscSpinner,
    MiscYaSplit,
    MiscYaPay,
    MiscVideo,
  };

  export type TImageKey = keyof typeof images;

  export function getURL(imageName: TImageKey): string | undefined {
    if (images?.hasOwnProperty(imageName)) {
      return images[imageName];

    } else {
      console.warn(`Image not found for name: ${imageName}`);
      return undefined;
    }
  }
}
